import axios from 'axios';

export default class NoteServices {
  static async getNotes({ model, modelId, params }) {
    const query = {
      model: 'Note',
      queries: [],
    };

    if (
      model === 'Subscription' ||
      model === 'Estimate' ||
      model === 'ServiceCall' ||
      model === 'Invoice' ||
      model === 'Deal' ||
      model === 'CustomerCallHistory'
    ) {
      const add = {
        field: 'model_id',
        value: modelId,
      };
      const other = {
        field: 'model',
        value: model,
      };
      query.queries.push(add);
      query.queries.push(other);
    } else {
      const t = {
        field: `${model}_id`,
        value: modelId,
      };
      query.queries.push(t);
    }

    const response = await axios.post('v2/search', query, { params });
    return response.data;
  }

  static async getNote(params) {
    const response = await axios.get('notes', { params });
    return response.data;
  }

  static async createNote(data) {
    const response = await axios.post('v2/create', data);
    return response.data;
  }

  static async updateNote({ id, content }) {
    return axios.post('note/update', { id, content });
  }

  static async deleteNote(id) {
    const response = await axios.delete(`note/${id}/delete`);
    return response.data;
  }

  static async saveInlineNote(modelId, modelType, content) {
    const response = await axios.post('note/inline/save', {
      model_id: modelId,
      model_type: modelType,
      content,
    });
    return response.data;
  }
}
